//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ImportColumnInputItem } from './ImportColumnInputItem';
import { StudentImportColumn } from './Enums';

export class StudentImportColumnInputItem extends ImportColumnInputItem {
    Column: StudentImportColumn = StudentImportColumn.StudentFirstName;

    constructor(initializer?: Partial<StudentImportColumnInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentImportColumnInputItem";
}
